export var MAKE_PUBLIC_PARAM = "makePublic";
